import {RegistrationSectorComponent} from './pages/products/product-complete-form/registration-sector/registration-sector.component';
import {PreFormDetailComponent} from './pages/products/product-pre-form/pre-form-detail/pre-form-detail.component';
import {AuthGuard} from './core/guards/authguard';
import {Routes} from '@angular/router';
import {SignGuard} from './core/guards/signGuard';
import { PermissionGuard } from './core/guards/permissionGuard';
import { NotPermittedGuard } from './core/guards/notPermittedGuard';

export const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},

  /**
   * Public Routes
   */
  {
    path: '',
    loadComponent: () => import('./pages/sign/sign.component').then((c) => c.SignComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/sign/login/login.component').then((c) => c.LoginComponent),
        canActivate: [SignGuard],
      },

      {
        path: 'recuperarsenha',
        loadComponent: () =>
          import('./pages/sign/forgot-password/forgot-password.component').then((c) => c.ForgotPasswordComponent),
        canActivate: [SignGuard],
      },
      {
        path: 'registro',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'fornecedor',
          },
          {
            path: 'fornecedor',
            loadComponent: () =>
              import('./pages/sign/suppliers-register/suppliers-register.component').then(
                (c) => c.suppliersRegisterComponent,
              ),
          },
        ],
        canActivate: [SignGuard],
      },
    ],
    canActivate: [SignGuard],
  },

  /**
   * Private Routes
   */

  { path: 'finalizar-cadastro',
    loadComponent: () =>
      import('./pages/awaiting-approval-panel/awaiting-approval-panel.component').then(
        (c) => c.AwaitingApprovalPanelComponent,
      ),
    canActivate: [AuthGuard],
  },

  { path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then((c) => c.DashboardComponent),
    data: {
      breadcrumb: 'Dashboard',
    },
    canActivate: [AuthGuard],
  },

  { path: 'cadastros',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'novo-produto',
        loadComponent: () =>
          import('./pages/register-pages/product-register/product-register.component').then(
            (c) => c.ProductRegisterComponent,
          ),
      },
      {
        path: 'novo-usuario',
        loadComponent: () =>
          import('./pages/register-pages/user-register/user-register.component').then((c) => c.UserRegisterComponent),
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: ['usuarios>acessar']
        },  
      },
      {
        path: 'novo-perfil',
        loadComponent: () =>
          import('./pages/register-pages/profile-register/profile-register.component').then(
            (c) => c.ProfileRegisterComponent,
          ),
        canActivate: [AuthGuard, PermissionGuard],
        data: {
          permissions: ['usuarios>acessar']
        },  
      },
    ],
  },

  { path: 'fornecedores',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'overview',
      },
      {
        path: 'overview',
        loadComponent: () => import('./pages/suppliers/suppliers.component').then((c) => c.FornecedoresComponent),
      },
      {
        path: 'detalhes/:id',
        loadComponent: () =>
          import('./pages/suppliers/supplier-detail/supplier-detail.component').then((c) => c.SupplierDetailComponent),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['novos-fornecedores>detalhes>validacaoCadastro', 'novos-fornecedores>detalhes>validacaoPreCadastro', 'novos-fornecedores>detalhes>associarGrupoCompra']
        }
      },
    ],
  },

  { path: 'Produtos',
    canActivate: [AuthGuard],
    
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'overview',
      },
      // Tabs Route
      {
        path: 'overview',
        loadComponent: () => import('./pages/products/products.component').then((c) => c.productsComponent),
      },

      // Dead Route
      {
        path: 'detalhes/:id',
        loadComponent: () =>
          import('./pages/products/product-detail/product-detail.component').then((c) => c.ProductDetailComponent),
      },

      // Pre-product Routes
      {
        path: 'pre-ficha/cadastrar',
        loadComponent: () =>
          import('./pages/products/product-pre-form/pre-form-register/pre-form-register.component').then(
            (c) => c.PreFormRegisterComponent,
          ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>cadastro>pre-ficha>cadastrar']
        }
      },
      {
        path: 'pre-ficha/detalhes/:id',
        loadComponent: () =>
          import('./pages/products/product-pre-form/pre-form-detail/pre-form-detail.component').then(
            (c) => c.PreFormDetailComponent,
          ),
      },

      // Complete-product Routes
      {
        path: 'ficha-completa/:id',
        loadComponent: () =>
          import('./pages/products/product-complete-form/complete-form-register/complete-form-register.component').then(
            (c) => c.CompleteFormRegisterComponent,
        ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>cadastro>ficha-completa>cadastrar']
        }
      },
      {
        path: 'ficha-completa/:id/farmacia',
        loadComponent: () =>
          import('./pages/products/product-complete-form/pharmacy-sector/pharmacy-sector.component').then(
            (c) => c.PharmacySectorComponent,
          ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>cadastro>ficha-completa>visao-farmacia']
        }
      },
      {
        path: 'ficha-completa/:id/setor-de-cadastro',
        loadComponent: () =>
          import('./pages/products/product-complete-form/registration-sector/registration-sector.component').then(
            (c) => c.RegistrationSectorComponent,
          ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>cadastro>ficha-completa>visao-cadastro']
        }
      },
      {
        path: 'ficha-completa/:id/web',
        loadComponent: () =>
          import('./pages/products/product-complete-form/web-sector/web-sector.component').then(
            (c) => c.WebSectorComponent,
          ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>cadastro>ficha-completa>visao-web']
        }
      },
      {
        path: 'ficha-completa/:id/gc',
        loadComponent: () =>
          import('./pages/products/product-complete-form/gc-sector/gc-sector.component').then(
            (c) => c.CompleteFormGCComponent,
        ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>cadastro>ficha-completa>visao-gc']
        }
      },
      {
        path: 'ficha-completa/:id/fiscal',
        loadComponent: () =>
          import('./pages/products/product-complete-form/tax-sector/tax-sector.component').then(
            (c) => c.TaxSectorComponent,
          ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>cadastro>ficha-completa>visao-fiscal']
        }
      },

      // Change Request Routes
      {
        path: 'alterar/:id/0/:ean',
        loadComponent: () =>
          import('./pages/products/products-change-requests/new-product-change-request/new-product-change-request.component').then(
            (c) => c.NewProductChangeRequestComponent,
          ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>detalhes>solicitacoesFornecedor>visao-fornecedor']
        }
      },
      {
        path: 'alterar/:id/web',
        loadComponent: () =>
          import('./pages/products/products-change-requests/web-product-change-request/web-product-change-request.component').then(
            (c) => c.WebProductChangeRequestComponent,
          ),
        canActivate: [PermissionGuard],
        data: {
          permissions: ['produto>detalhes>solicitacoesFornecedor>visao-web']
        }
      },
      {
        path: 'alterar/:id/correcao',
        loadComponent: () =>
          import('./pages/products/products-change-requests/edit-product-change-request/edit-product-change-request.component').then(
            (c) => c.EditProductChangeRequestComponent,
          ),
          canActivate: [PermissionGuard],
          data: {
            permissions: ['produto>detalhes>solicitacoesFornecedor>visao-fornecedor']
          }
      },
      {
        path: 'alterar/:id/cadastro',
        loadComponent: () =>
          import('./pages/products/products-change-requests/registration-product-change-request/registration-product-change-request.component').then(
            (c) => c.RegistrationProductChangeRequestComponent,
          ),
        data: {
          permissions: ['produto>detalhes>solicitacoesFornecedor>visao-cadastro']
        }
      },
    ],
  },

  { path: 'lojas',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['nossas-lojas>acessar']
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/stores/stores.component').then((c) => c.StoresComponent),
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./pages/stores/store-detail/store-detail.component').then((c) => c.StoreEditComponent),
      },
    ],
  },

  { path: 'entregas',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['agendamentos>acessar']
    },  
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'overview',
      },
      {
        path: 'overview',
        loadComponent: () => import('./pages/delivers/delivers.component').then((c) => c.DeliverSchedulingComponent),
      },
    ],
  },

  { path: 'vendas-e-estoque',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['vendas-e-estoque>acessar']
    },    
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'overview',
      },
      {
        path: 'overview',
        loadComponent: () =>
          import('./pages/sales-and-inventory/sales-and-inventory.component').then((c) => c.SalesAndInventoryComponent),
      },
      {
        path: 'estoque/:id',
        loadComponent: () =>
          import('./pages/sales-and-inventory/product-inventory/product-inventory.component').then(
            (c) => c.productInventoryComponent,
          ),
      },
    ],
  },

  { path: 'relatorios',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['relatorios>acessar']
    },  
    children: [
      {
        path: '',
        redirectTo: 'agendamentos',
        pathMatch: 'full',
      },
      {
        path: 'extrair',
        loadComponent: () => import('./pages/reports/extract/extract.component').then((c) => c.ExtractComponent),
      },
      {
        path: 'agendamentos',
        loadComponent: () =>
          import('./pages/reports/appointments/appointments.component').then((c) => c.AppointmentsComponent),
      },
    ],
  },

  { path: 'pedidos',
    canActivate: [AuthGuard, PermissionGuard],
    loadComponent: () => import('./pages/order-requests/orders.component').then((c) => c.OrdersComponent),
    data: {
      permissions: ['pedidos-de-compras>acessar']
    },  
  },

  { path: 'config',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/configs/configs.component').then((c) => c.ConfigsComponent),
  },

  { path: 'acessos',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['usuarios>acessar']
    },   
    loadComponent: () => import('./pages/access-panel/access-panel.component').then((c) => c.AccessPanelComponent),
  },

  { path: 'usuario/detalhe/:id',
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['usuarios>acessar']
    },      
    loadComponent: () =>
      import('./pages/access-panel/users/user-detail/user-detail.component').then((c) => c.UserDetailComponent),
  },

  { path: 'perfil/detalhes/:id',
    loadComponent: () =>
      import('./pages/access-panel/access-profiles/profiles-detail/profiles-detail.component').then(
        (c) => c.ProfilesDetailComponent,
      ),
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permissions: ['usuarios>acessar']
    },  
  },

  {path: '**', redirectTo: 'dashboard', pathMatch: 'full'},
];
